import {Images} from "../constants/Images";
import React from "react";

export const BackgroundImages = ({auth = true}) => {
    return (
        <div className={`w-100 h-100 ${auth ? 'account-background-container' : 'concert-background-container'}`}>
            <img src={Images.ICON_ACCOUNT_LEFT} className="i-betarky" alt=""/>
            <img src={Images.ICON_ACCOUNT_RIGHT} className="i-betarky" alt=""/>
        </div>
    )
}